/**
 * =========================================================================================
 * UForceLogout — action types + window-event channel name
 * =========================================================================================
 **/

export const FORCE_LOGOUT_ACTIONS = {
    SET: 'SET_FORCE_LOGOUT',
    CLEAR: 'CLEAR_FORCE_LOGOUT',
};

// Fallback channel — used only when an app does not expose useSocket
// through UFrameworkProvider. See helpers / index for usage.
export const FORCE_LOGOUT_WINDOW_EVENT = 'ubs:force-logout';
